import { PaidMethod } from '@constants';
// import ErrorIcon from '@mui/icons-material/Error';
import { paymentMethods } from '@pages/payment/const';
import { TREMENDOUS_HOVER, SHIPPING_FEE_HOVER, SERVICE_FEE_HOVER } from '@constants/claim';
import { Panel } from '../panel';
import classes from './index.module.css';
import InfoHover from '../Hover';

// const hover = 'You can choose to receive the amount via virtual Visa card, PayPal transfer, or ACH transfer to your bank account.';

/** 获取金额的有效值 */
const getValidMoneyValue = (value) => {
  if (!value) {
    return '--';
  }
  if (Number.isNaN(Number(value))) {
    return value;
  }
  return `${Number(value).toFixed(2)}`;
};

// eslint-disable-next-line max-len
// const getResolutionValue = (resolution) => (resolution === PaidMethod.Tremendous ? 'Refund via virtual visa card' : 'To be determined');

const Resolution = ({ title, resolution, time }) => (
  <>
    <section className={classes.resolution_title}>
      <span className={classes.title_bold}>Transfer method:</span>
      <span className={classes.method}>
        {/* 兼容老逻辑 原来resolution 返回的是显示文案，rc2.0改成返回payment code，所以兼容老逻辑，使得正常显示resolution文案 */}
        {title || resolution}
        {/*  payment 选择Direct payment via your preferred method 才显示hover */}
        {resolution === PaidMethod.Tremendous && (
          <InfoHover title={TREMENDOUS_HOVER} />
        )}
      </span>

    </section>
    {time
      && (
        <span className={classes.processing_time}>
          {time}
        </span>
      )}
  </>
);
/** BP review 面板 */
export const BPReviewPanel = ({ reviewInfo }) => {
  if (!reviewInfo) {
    return null;
  }

  const { refundTotalValue, resolution } = reviewInfo || {};
  const { title, time } = paymentMethods[resolution] || {};

  return (
    <Panel>
      <section className={classes.reported_title}>
        <span className={classes.title_bold}>Estimated refund:</span>
        <span>
          {refundTotalValue}
        </span>
      </section>

      <section className={classes.bp_resolution}>
        <Resolution title={title} time={time} resolution={resolution} />
      </section>
    </Panel>
  );
};

/** RA review 面板 */
export const RAReviewPanel = ({ reviewInfo, children }) => {
  if (!reviewInfo) {
    return null;
  }
  const {
    refundTotalValue, itemTotalValue, taxInclude, tax, shippingFee, resolution, transactionFee, shippingOnOwn, reimbursedShippingFee, reimbursedServiceFee,
  } = reviewInfo || {};
  const { title, time } = paymentMethods[resolution] || {};
  const footer = (
    <section className={classes.resolution}>
      <Resolution title={title} time={time} resolution={resolution} />
    </section>
  );

  return (
    <Panel footer={footer}>
      <section className={`${classes.title_bold} ${classes.reported_ra_title}`}>Estimated refund</section>
      <section className={classes.reported_line}>
        <section>Items subtotal</section>
        <section className={classes.reported_money}>{getValidMoneyValue(itemTotalValue)}</section>
      </section>
      <section className={classes.reported_line}>
        <section>
          Tax
          {taxInclude ? ' (included)' : ''}
        </section>
        <section className={classes.reported_money}>{getValidMoneyValue(tax)}</section>
      </section>
      {reimbursedServiceFee && (
        <section className={classes.reported_line}>
          <section style={{ display: 'flex' }}>
            Service fee
            <InfoHover title={SERVICE_FEE_HOVER} />
          </section>
          <section className={classes.reported_money}>{reimbursedServiceFee ? `${getValidMoneyValue(reimbursedServiceFee)}` : '--'}</section>
        </section>
      )}
      {reimbursedShippingFee && (
        <section className={classes.reported_line}>
          <section style={{ display: 'flex' }}>
            Refund shipping
            <InfoHover title={SHIPPING_FEE_HOVER} />
          </section>
          <section className={classes.reported_money}>{reimbursedShippingFee ? `${getValidMoneyValue(reimbursedShippingFee)}` : '--'}</section>
        </section>
      )}

      <section className={classes.reported_line}>
        <section>
          Return shipping fee (
          {shippingOnOwn ? 'Ship on your own' : 'Label generated by Seel'}
          )
        </section>
        <section className={classes.reported_money}>{shippingFee ? `${getValidMoneyValue(shippingFee)}` : '--'}</section>
      </section>
      <section className={classes.reported_line}>
        <section>Transaction fee</section>
        <section className={classes.reported_money}>{transactionFee ? `${getValidMoneyValue(transactionFee)}` : '--'}</section>
      </section>
      {children}
      <section className={classes.reported_line}>
        <section className={classes.title_bold}>Total</section>
        <section className={classes.title_bold} style={{ marginRight: '0px' }}>
          {getValidMoneyValue(refundTotalValue)}
        </section>
      </section>
    </Panel>
  );
};

/** dhgate review 面板 */
export const DhgateReviewPanel = ({ reviewInfo }) => {
  if (!reviewInfo) {
    return null;
  }
  const {
    refundTotalValue, itemTotalValue, tax, reimbursedShippingFee, resolution, taxInclude,
  } = reviewInfo || {};
  const { title, time } = paymentMethods[resolution] || {};
  const footer = (
    <section className={classes.resolution}>
      <Resolution title={title} time={time} resolution={resolution} />
    </section>
  );

  return (
    <Panel footer={footer}>
      <section className={`${classes.title_bold} ${classes.reported_ra_title}`}>Estimated refund</section>
      <section className={classes.reported_line}>
        <section>Item(s) subtotal</section>
        <section className={classes.reported_money}>{getValidMoneyValue(itemTotalValue)}</section>
      </section>
      <section className={classes.reported_line}>
        <section>
          Tax
          {taxInclude ? ' (included)' : ''}
        </section>
        <section className={classes.reported_money}>{getValidMoneyValue(tax)}</section>
      </section>

      <section className={classes.reported_line}>
        <section style={{ display: 'flex' }}>
          Original shipping
          <InfoHover title={SHIPPING_FEE_HOVER} />

        </section>
        <section className={classes.reported_money}>{reimbursedShippingFee ? `${getValidMoneyValue(reimbursedShippingFee)}` : '--'}</section>
      </section>
      <section className={classes.reported_line}>
        <section className={classes.title_bold}>Total</section>
        <section className={classes.title_bold} style={{ marginRight: '0px' }}>
          {getValidMoneyValue(refundTotalValue)}
        </section>
      </section>
    </Panel>
  );
};
